import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "reducers";
import { IConstructionStatisticsRequestParams } from "../domain/IConstructionStatisticsRequestParams";
import { IFinancialStatistics } from "../domain/IFinancialStatistics";
import { StatisticsService } from "../services/statistics.service";

interface FinancialStatisticsState {
  loading: boolean;
  statistics?: IFinancialStatistics;
  error: any;
}

const initialState: FinancialStatisticsState = {
  loading: false,
  statistics: undefined,
  error: undefined,
};

export const getFinancialStatistics = createAsyncThunk(
  "Statistics/getFinancialStatistics",
  async (data?: IConstructionStatisticsRequestParams) => {
    try {
      const result = await StatisticsService.getFinancialStatistics(data);
      return result;
    } catch (err) {
      setError(err);
    }
  }
);


export const FinancialStatisticsSlice = createSlice({
  name: "ConstructionStatistics",
  initialState: initialState,
  reducers: {
    setFinancialStatistics: (
      state,
      action: PayloadAction<IFinancialStatistics>
    ) => {
      state.statistics = action.payload;
    },
    setError: (state, action: PayloadAction<any>) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getFinancialStatistics.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getFinancialStatistics.fulfilled, (state, action) => {
      state.loading = false;
      state.statistics = action.payload ? action.payload : undefined;
    });
    builder.addCase(getFinancialStatistics.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error;
    });
  },
});

export const selectState = (state: RootState) => state.statistics.financial;

export const { setError } = FinancialStatisticsSlice.actions;

export default FinancialStatisticsSlice.reducer;
